import styled from 'styled-components'
import { Button, Input } from '../ui'

export const ProxyList = styled.div`
	max-height: 400px;
	overflow-y: auto;
	margin-top: 20px;
`

export const ProxyItem = styled.div`
	padding: 16px;
	border: 1px solid #374151;
	border-radius: 8px;
	margin-bottom: 12px;
	background: #1f2937;
	transition: background-color 0.2s ease;

	&:hover {
		background: #374151;
	}
`

export const ProxyInfo = styled.div`
	margin-bottom: 12px;
`

export const ProxyName = styled.div`
	font-weight: 600;
	color: #f9fafb;
	margin-bottom: 4px;
`

export const ProxyAddress = styled.div`
	font-size: 14px;
	color: #9ca3af;
	font-family: monospace;
	margin-bottom: 4px;
`

export const ProxyDate = styled.div`
	font-size: 12px;
	color: #6b7280;
`

export const ActionButtons = styled.div`
	display: flex;
	gap: 8px;
	flex-shrink: 0;
`

export const EditButton = styled(Button)`
	padding: 10px 20px;
	font-size: 14px;
	background: #8b5cf6;
	border-radius: 16px;
	min-width: 70px;
	height: 36px;
	
	&:hover {
		background: #7c3aed;
	}
`

export const DeleteButton = styled(Button)`
	padding: 10px 20px;
	font-size: 14px;
	background: #ef4444;
	border-radius: 16px;
	min-width: 70px;
	height: 36px;
	
	&:hover {
		background: #dc2626;
	}
`

export const AddNewSection = styled.div`
	margin: 20px 0;
	padding: 16px;
	border: 2px dashed #374151;
	border-radius: 8px;
	background: #111827;
`

export const AddButton = styled(Button)`
	width: 100%;
	background: #10b981;
	padding: 12px 20px;
	font-size: 14px;
	
	&:hover {
		background: #059669;
	}
`

export const SaveButton = styled(Button)`
	padding: 10px 20px;
	font-size: 14px;
	background: #10b981;
	border-radius: 16px;
	min-width: 70px;
	height: 36px;
	
	&:hover {
		background: #059669;
	}
`

export const CancelButton = styled(Button)`
	padding: 10px 20px;
	font-size: 14px;
	background: #6b7280;
	border-radius: 16px;
	min-width: 70px;
	height: 36px;
	
	&:hover {
		background: #4b5563;
	}
`

export const EmptyState = styled.div`
	text-align: center;
	padding: 40px 20px;
	color: #9ca3af;
	font-size: 16px;
`

export const SearchInput = styled(Input)`
	margin-bottom: 0;
	margin-top: 20px;
`

